"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuggestions = void 0;
var _debounce = require("debounce");
var _react = require("react");
var _constants = require("../../constants");
var _models = require("../../models");
var _TranslationKey = require("../../models/TranslationKey");
var _fetchAddressSearchResult = require("./fetchAddressSearchResult");
var _useAddressSuggestionSearchQuery = require("./useAddressSuggestionSearchQuery");
const useSuggestions = (api, maxResults, minSearchLength, country, searchDelay) => {
  const [suggestions, setSuggestions] = (0, _react.useState)([]);
  const [isOpen, setOpen] = (0, _react.useState)(false);
  const [inputText, setInputText] = (0, _react.useState)('');
  const [searchInputTarget, setTarget] = (0, _react.useState)(undefined);
  const clearSuggestions = () => {
    setSuggestions([]);
    setInputText('');
    setOpen(false);
  };
  const handleSearch = async (searchText, pathKey) => {
    setInputText(searchText);
    try {
      const suggestedAddresses = await (0, _useAddressSuggestionSearchQuery.getSuggestions)(api, minSearchLength, maxResults, searchText, country, pathKey);
      if (suggestedAddresses != null) {
        setSuggestions([]);
        setSuggestions(suggestedAddresses);
        setOpen(true);
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };
  const fetchFullAddress = async addressNodeId => {
    try {
      const result = await (0, _fetchAddressSearchResult.fetchAddressSearchResult)(api, addressNodeId, country);
      clearSuggestions();
      searchInputTarget?.blur();
      return result;
    } catch (error) {
      return _models.FetchResult.errorFor({
        type: 'Area'
      });
    }
  };
  const getNoOptionsLabel = () => inputText.length < 3 ? _TranslationKey.TranslationKey.typeAtLeastThreeCharacters : _TranslationKey.TranslationKey.noSuggestions;
  const onClick = async () => {
    if (inputText !== '' && !isOpen) {
      await handleSearch(inputText);
    }
  };
  const onChange = (0, _debounce.debounce)(async (event, value) => {
    const searchInput = event.target;
    if (!searchInputTarget) {
      setTarget(searchInput);
    }
    if (searchInput.value === '') {
      clearSuggestions();
    } else {
      await handleSearch(value.trimStart());
    }
  }, searchDelay ?? _constants.SEARCH_DELAY);
  return {
    isOpen,
    setOpen,
    suggestions,
    inputText,
    onClick,
    onChange,
    handleSearch,
    getNoOptionsLabel,
    fetchFullAddress
  };
};
exports.useSuggestions = useSuggestions;
//# sourceMappingURL=useSuggestions.js.map